/* eslint-disable */
/* tslint:disable */
/**
 * AUTO-GENERATED — do not edit manually.
 * Generated by scripts/extractReadMethods.ts from the OpenAPI spec.
 *
 * Maps API class (the constructor reference) → Set of GET operation IDs for
 * that class. Used by the API proxy to determine which methods are reads
 * (pass-through) vs mutations (trigger refetch).
 *
 * Keyed by the class CONSTRUCTOR, not its name. Production builds minify class
 * names (`AttachmentsApi.name` becomes `"e"`), so a name-keyed lookup silently
 * misses and every method gets misclassified as a mutation, firing spurious
 * refetches. The constructor reference is the same object before and after
 * minification, so identity lookup is minification-proof.
 */
import { ActivitiesApi } from "@freightsimple/generated-hubble-openapi-client/apis/ActivitiesApi";
import { AdSpendApi } from "@freightsimple/generated-hubble-openapi-client/apis/AdSpendApi";
import { AdminLogsApi } from "@freightsimple/generated-hubble-openapi-client/apis/AdminLogsApi";
import { AgentHostPreviewsApi } from "@freightsimple/generated-hubble-openapi-client/apis/AgentHostPreviewsApi";
import { AmyApi } from "@freightsimple/generated-hubble-openapi-client/apis/AmyApi";
import { ApiKeysApi } from "@freightsimple/generated-hubble-openapi-client/apis/ApiKeysApi";
import { AttachmentsApi } from "@freightsimple/generated-hubble-openapi-client/apis/AttachmentsApi";
import { BackfillsApi } from "@freightsimple/generated-hubble-openapi-client/apis/BackfillsApi";
import { CalendarStatsApi } from "@freightsimple/generated-hubble-openapi-client/apis/CalendarStatsApi";
import { CarrierCRMApi } from "@freightsimple/generated-hubble-openapi-client/apis/CarrierCRMApi";
import { CarrierDocumentsApi } from "@freightsimple/generated-hubble-openapi-client/apis/CarrierDocumentsApi";
import { CarrierEmailsApi } from "@freightsimple/generated-hubble-openapi-client/apis/CarrierEmailsApi";
import { CarrierInvoiceApi } from "@freightsimple/generated-hubble-openapi-client/apis/CarrierInvoiceApi";
import { CarrierInvoiceAuditApi } from "@freightsimple/generated-hubble-openapi-client/apis/CarrierInvoiceAuditApi";
import { CarrierMeetingsApi } from "@freightsimple/generated-hubble-openapi-client/apis/CarrierMeetingsApi";
import { CarrierProBlockApi } from "@freightsimple/generated-hubble-openapi-client/apis/CarrierProBlockApi";
import { CarrierRequestAuditApi } from "@freightsimple/generated-hubble-openapi-client/apis/CarrierRequestAuditApi";
import { CarrierRestrictionsApi } from "@freightsimple/generated-hubble-openapi-client/apis/CarrierRestrictionsApi";
import { CarriersApi } from "@freightsimple/generated-hubble-openapi-client/apis/CarriersApi";
import { ClaudeApi } from "@freightsimple/generated-hubble-openapi-client/apis/ClaudeApi";
import { CompaniesApi } from "@freightsimple/generated-hubble-openapi-client/apis/CompaniesApi";
import { CompanyApiRateLimitsApi } from "@freightsimple/generated-hubble-openapi-client/apis/CompanyApiRateLimitsApi";
import { CompanyDocumentsApi } from "@freightsimple/generated-hubble-openapi-client/apis/CompanyDocumentsApi";
import { CompanyLabelsApi } from "@freightsimple/generated-hubble-openapi-client/apis/CompanyLabelsApi";
import { CompanyListsApi } from "@freightsimple/generated-hubble-openapi-client/apis/CompanyListsApi";
import { CompanyMeetingsApi } from "@freightsimple/generated-hubble-openapi-client/apis/CompanyMeetingsApi";
import { CompanyWebhooksApi } from "@freightsimple/generated-hubble-openapi-client/apis/CompanyWebhooksApi";
import { CustomerInvoiceApi } from "@freightsimple/generated-hubble-openapi-client/apis/CustomerInvoiceApi";
import { CustomerSpecificPricingApi } from "@freightsimple/generated-hubble-openapi-client/apis/CustomerSpecificPricingApi";
import { DialpadCallsApi } from "@freightsimple/generated-hubble-openapi-client/apis/DialpadCallsApi";
import { DocumentsApi } from "@freightsimple/generated-hubble-openapi-client/apis/DocumentsApi";
import { EDIApi } from "@freightsimple/generated-hubble-openapi-client/apis/EDIApi";
import { EnvironmentSyncApi } from "@freightsimple/generated-hubble-openapi-client/apis/EnvironmentSyncApi";
import { ExperimentsApi } from "@freightsimple/generated-hubble-openapi-client/apis/ExperimentsApi";
import { FreightClaimsApi } from "@freightsimple/generated-hubble-openapi-client/apis/FreightClaimsApi";
import { FrontPluginApi } from "@freightsimple/generated-hubble-openapi-client/apis/FrontPluginApi";
import { FuelSurchargeValuesApi } from "@freightsimple/generated-hubble-openapi-client/apis/FuelSurchargeValuesApi";
import { GitApi } from "@freightsimple/generated-hubble-openapi-client/apis/GitApi";
import { IntegrationsApi } from "@freightsimple/generated-hubble-openapi-client/apis/IntegrationsApi";
import { KlaviyoApi } from "@freightsimple/generated-hubble-openapi-client/apis/KlaviyoApi";
import { MapApi } from "@freightsimple/generated-hubble-openapi-client/apis/MapApi";
import { OpenApiTypesApi } from "@freightsimple/generated-hubble-openapi-client/apis/OpenApiTypesApi";
import { OperationsTaskApi } from "@freightsimple/generated-hubble-openapi-client/apis/OperationsTaskApi";
import { PeopleApi } from "@freightsimple/generated-hubble-openapi-client/apis/PeopleApi";
import { PeopleInterviewsApi } from "@freightsimple/generated-hubble-openapi-client/apis/PeopleInterviewsApi";
import { PeoplePayrollApi } from "@freightsimple/generated-hubble-openapi-client/apis/PeoplePayrollApi";
import { PeopleRecruitingApi } from "@freightsimple/generated-hubble-openapi-client/apis/PeopleRecruitingApi";
import { PeopleSoftwareApi } from "@freightsimple/generated-hubble-openapi-client/apis/PeopleSoftwareApi";
import { PeopleTeamApi } from "@freightsimple/generated-hubble-openapi-client/apis/PeopleTeamApi";
import { PeopleTeamMeetingsApi } from "@freightsimple/generated-hubble-openapi-client/apis/PeopleTeamMeetingsApi";
import { PeopleTeamsApi } from "@freightsimple/generated-hubble-openapi-client/apis/PeopleTeamsApi";
import { PingApi } from "@freightsimple/generated-hubble-openapi-client/apis/PingApi";
import { PresenceApi } from "@freightsimple/generated-hubble-openapi-client/apis/PresenceApi";
import { PublicApiRequestsApi } from "@freightsimple/generated-hubble-openapi-client/apis/PublicApiRequestsApi";
import { QueueApi } from "@freightsimple/generated-hubble-openapi-client/apis/QueueApi";
import { QuoteTestApi } from "@freightsimple/generated-hubble-openapi-client/apis/QuoteTestApi";
import { QuotesApi } from "@freightsimple/generated-hubble-openapi-client/apis/QuotesApi";
import { SavedCommoditiesUploadApi } from "@freightsimple/generated-hubble-openapi-client/apis/SavedCommoditiesUploadApi";
import { SavedViewsApi } from "@freightsimple/generated-hubble-openapi-client/apis/SavedViewsApi";
import { ShipmentActivityApi } from "@freightsimple/generated-hubble-openapi-client/apis/ShipmentActivityApi";
import { ShipmentInsuranceApi } from "@freightsimple/generated-hubble-openapi-client/apis/ShipmentInsuranceApi";
import { ShipmentsApi } from "@freightsimple/generated-hubble-openapi-client/apis/ShipmentsApi";
import { SignalAlarmRulesApi } from "@freightsimple/generated-hubble-openapi-client/apis/SignalAlarmRulesApi";
import { SignalAlarmsApi } from "@freightsimple/generated-hubble-openapi-client/apis/SignalAlarmsApi";
import { SignalsApi } from "@freightsimple/generated-hubble-openapi-client/apis/SignalsApi";
import { StarredObjectsApi } from "@freightsimple/generated-hubble-openapi-client/apis/StarredObjectsApi";
import { StatsApi } from "@freightsimple/generated-hubble-openapi-client/apis/StatsApi";
import { StickiesApi } from "@freightsimple/generated-hubble-openapi-client/apis/StickiesApi";
import { SupportEmailApi } from "@freightsimple/generated-hubble-openapi-client/apis/SupportEmailApi";
import { TechnicalApi } from "@freightsimple/generated-hubble-openapi-client/apis/TechnicalApi";
import { TodosApi } from "@freightsimple/generated-hubble-openapi-client/apis/TodosApi";
import { TripwiresApi } from "@freightsimple/generated-hubble-openapi-client/apis/TripwiresApi";

// Permissive constructor type: the map only ever does identity lookups, so the
// exact constructor signature doesn't matter.
type ApiClassRef = abstract new (...args: any[]) => object;

export const READ_METHODS_BY_API = new Map<ApiClassRef, ReadonlySet<string>>([
  [ActivitiesApi, new Set(["getById"])],
  [AdSpendApi, new Set(["getAllAdSpend"])],
  [AdminLogsApi, new Set(["getLogsForAdmin"])],
  [AgentHostPreviewsApi, new Set(["getPreviews", "getWorktrees"])],
  [AmyApi, new Set(["upcomingAmyShipmentTasks"])],
  [ApiKeysApi, new Set(["getApiKeyWithCompanyAndUsageData"])],
  [AttachmentsApi, new Set(["downloadPdfSource", "getPdfSourceDocuments"])],
  [BackfillsApi, new Set(["getBackfills"])],
  [
    CalendarStatsApi,
    new Set(["companyDataForCalendars", "companyDataForQuotingCalendar"]),
  ],
  [
    CarrierCRMApi,
    new Set(["carrier", "carriers", "contacts", "notes", "significantEvents"]),
  ],
  [
    CarrierDocumentsApi,
    new Set([
      "downloadByReferenceNumber",
      "downloadCarrierDocumentByS3Path",
      "downloadThumbnailByThumbnailS3Key",
      "getByReferenceNumber",
      "getDocumentsForCarrier",
    ]),
  ],
  [
    CarrierEmailsApi,
    new Set([
      "downloadAttachment",
      "getEmail",
      "listEmailsForCarrier",
      "recentMessages",
    ]),
  ],
  [
    CarrierInvoiceApi,
    new Set([
      "getCarrierInvoiceByChequeNumber",
      "getCarrierRequestAuditForQuote",
      "getCarrierRequestAuditForSelectedQuote",
      "getPaymentProperties",
      "getShipmentsOverdueInvoices",
      "previewEmailForCarrierInvoice",
      "previewEmailForOverchargeClaim",
      "viewCarrierCreditNotes",
      "viewCarrierInvoices",
    ]),
  ],
  [
    CarrierInvoiceAuditApi,
    new Set([
      "getAllInvoiceCarrierNotes",
      "getAllInvoiceProblemNotes",
      "openInvoiceAudits",
    ]),
  ],
  [
    CarrierMeetingsApi,
    new Set(["getMeeting", "listMeetingsForCarrier", "recentMeetings"]),
  ],
  [CarrierProBlockApi, new Set(["getAllProBlocks", "getCarrierAccounts"])],
  [
    CarrierRequestAuditApi,
    new Set(["getAuditsByTrackingLine", "getCarrierRequestAuditById"]),
  ],
  [
    CarrierRestrictionsApi,
    new Set(["getAllCarrierRestrictions", "getHistoryForId"]),
  ],
  [
    CarriersApi,
    new Set([
      "generateCarrierLoginUrl",
      "getCarrierInfo",
      "getCarrierPortalActivity",
      "getCarrierProperties",
      "getCarrierServices",
      "getCarriersWithFSCLevels",
      "getHistoryRecordsForCarrierProperties",
      "getServiceInfo",
      "summarizeExpectedAmyTasks",
    ]),
  ],
  [ClaudeApi, new Set(["getClaudeConversationItems"])],
  [
    CompaniesApi,
    new Set([
      "companyQuoteReport",
      "getAvailableCompaniesForLinking",
      "getBookedShipmentsForCompany",
      "getCompany",
      "getCompanyApiData",
      "getCompanyBranch",
      "getCompanyShipmentSummaries",
      "getCompanyUsers",
      "getDashboardUsersTableData",
      "getLinkedCompanies",
      "getPasswordResetLinkForUserFromHubble",
      "getSavedBrokersForCompany",
      "getSavedCommoditiesForCompany",
      "getShipmentReportsForCompany",
      "listInvitationsByCompany",
      "viewCompanyData",
      "viewIndividualShipments",
    ]),
  ],
  [CompanyApiRateLimitsApi, new Set(["list"])],
  [
    CompanyDocumentsApi,
    new Set([
      "downloadCompanyDocument",
      "downloadCompanyDocumentById",
      "downloadCompanyDocumentThumbnail",
      "getCompanyDocument",
      "getCompanyDocuments",
    ]),
  ],
  [
    CompanyLabelsApi,
    new Set([
      "getAllLabelGroupsWithLabels",
      "getAllLabelsGroup",
      "getCompaniesByLabels",
      "getCompanyLabels",
      "getCompanyLabelsWithLabelGroup",
      "getLabelGroupById",
      "getLabelGroupWithLabelsById",
      "getLabelsByCompanyIds",
    ]),
  ],
  [CompanyListsApi, new Set(["getAllLists", "getListDetail"])],
  [
    CompanyMeetingsApi,
    new Set([
      "getCompanyMeeting",
      "listMeetingsForCompany",
      "recentCompanyMeetings",
    ]),
  ],
  [
    CompanyWebhooksApi,
    new Set([
      "getActiveWebhooksForCompany",
      "getActiveWebhooksForEvent",
      "getWebhook",
      "getWebhookDelivery",
      "listWebhookDeliveries",
      "listWebhooksForCompany",
    ]),
  ],
  [
    CustomerInvoiceApi,
    new Set([
      "generateEdi210",
      "getMismatchedCustomerInvoices",
      "getOpenAdditionalCharges",
      "viewCustomerInvoices",
    ]),
  ],
  [
    CustomerSpecificPricingApi,
    new Set([
      "agreementUsageStats",
      "evaluateAgreedCoverage",
      "evaluateCoverage",
      "getAllCustomerSpecificPricingAgreements",
    ]),
  ],
  [DialpadCallsApi, new Set(["activeIncomingCall", "salesCallLiveStatus"])],
  [
    DocumentsApi,
    new Set([
      "downloadDocumentById",
      "downloadDocumentByS3Path",
      "downloadDocumentsAsZip",
      "downloadThumbnailByS3Path",
    ]),
  ],
  [
    EDIApi,
    new Set([
      "getDeliverySettings",
      "getOutboundInvoices",
      "getOutboundTracking",
    ]),
  ],
  [EnvironmentSyncApi, new Set(["syncFuelSurchargeValues"])],
  [
    ExperimentsApi,
    new Set([
      "getExperimentDetail",
      "getExperimentRunDetail",
      "getExperimentRunSnapshots",
      "getExperimentRuns",
      "getExperimentShipmentReports",
      "getFilteredExperimentShipmentReports",
      "listExperiments",
    ]),
  ],
  [FreightClaimsApi, new Set(["getById_1"])],
  [FrontPluginApi, new Set(["downloadPdfSource_1", "getPdfSourceDocuments_1"])],
  [
    FuelSurchargeValuesApi,
    new Set([
      "getAllFCAFuelSurchargeValuesHistory",
      "getAllFuelSurchargeValues",
      "getHistoryRecordsForId",
    ]),
  ],
  [GitApi, new Set(["getGitShaEP"])],
  [
    IntegrationsApi,
    new Set([
      "bigCommerceCustomerGroups",
      "bigCommerceProducts",
      "getAllIntegrations",
    ]),
  ],
  [KlaviyoApi, new Set(["getLists"])],
  [MapApi, new Set(["getCompanies"])],
  [OpenApiTypesApi, new Set(["exportTypes"])],
  [
    OperationsTaskApi,
    new Set([
      "getAllOperationsTasks",
      "getByShipmentId",
      "getByShipmentIdAndType",
      "getOldestNotDoneByShipmentId",
      "getOperationsTaskById",
    ]),
  ],
  [PeopleApi, new Set(["engagementLetter", "me", "myProfile"])],
  [
    PeopleInterviewsApi,
    new Set(["getInterview", "listForApplication", "recentInterviewMeetings"]),
  ],
  [PeoplePayrollApi, new Set(["getPayRun", "listPayRuns"])],
  [
    PeopleRecruitingApi,
    new Set(["getApplication", "getResumeData", "listApplications"]),
  ],
  [PeopleSoftwareApi, new Set(["getSoftware", "listSoftware"])],
  [
    PeopleTeamApi,
    new Set(["engagementLetterForMember", "getTeamMember", "listTeamMembers"]),
  ],
  [
    PeopleTeamMeetingsApi,
    new Set(["getTeamMeeting", "listForTeamMember", "recentTeamMeetings"]),
  ],
  [PeopleTeamsApi, new Set(["getTeam", "listTeams"])],
  [PingApi, new Set(["index"])],
  [PresenceApi, new Set(["getViewers"])],
  [
    PublicApiRequestsApi,
    new Set(["listForApiKey", "listForCompany", "listForTraceId"]),
  ],
  [QueueApi, new Set(["getQueueStatus", "listQueueTasks"])],
  [
    QuoteTestApi,
    new Set(["exportData", "getAllGroups", "getBasicScenario", "getScenario"]),
  ],
  [
    QuotesApi,
    new Set([
      "carrierRequestAuditsForQuote",
      "fetchCarriersThatProvideEmailQuotes",
      "getCarrierQuotingProblems",
      "getFedExTransitTime",
      "getQuoteById",
      "getQuoteContactsData",
      "getQuoteGroupState",
      "getQuoteLogsForCarrier",
      "getQuoteLogsForShipment",
      "getQuotePdf",
      "getTruckloadTransitTime",
      "getVisibilityHistory",
      "listCarrierAndServiceTypes",
      "listCarrierAndServiceTypesThatSupportInstantQuoting",
      "previewRequestQuoteEmail",
      "viewQuotesScreenData",
    ]),
  ],
  [SavedCommoditiesUploadApi, new Set(["downloadTemplate"])],
  [SavedViewsApi, new Set(["getAllViews", "getViewDetail"])],
  [ShipmentActivityApi, new Set(["getActivity"])],
  [ShipmentInsuranceApi, new Set(["viewInsuranceCertificateDetails"])],
  [
    ShipmentsApi,
    new Set([
      "carrierEmailsForShipment",
      "carrierRequestAuditsForShipment",
      "fetchShipmentsThatNeedInsurance",
      "generateEdi204",
      "generateEdi214",
      "generateScenarioCodeForShipment",
      "getActiveShipments",
      "getAutomaticallyFetchTrackingUpdates",
      "getCancelledShipments",
      "getClaims",
      "getFedExAddressValidationInformation",
      "getLostShipments",
      "getNotesForShipment",
      "getPendingCustomsClearance",
      "getRelatedPickups",
      "getShipmentById",
      "getShipmentClaimsTabById",
      "getShipmentContactsTabById",
      "getShipmentPaymentMethodInfoById",
      "getShipmentReportById",
      "getShipmentsPerCarrier",
      "getShipmentsPerCarrierWithAudits",
      "getShipmentsWithManualQuoting",
      "getShipmentsWithOperationalTasksOpen",
      "previewCancelPickupEmail",
      "publicApiRequestAuditsForShipment",
      "recentManualQuotes",
      "sentEdi204s",
      "viewCarrierPickupNumberHistory",
      "viewProNumberHistory",
      "webhookDeliveriesForShipment",
    ]),
  ],
  [SignalAlarmRulesApi, new Set(["getSignalAlarmRules"])],
  [
    SignalAlarmsApi,
    new Set([
      "getActiveAlarms",
      "getAlarmById",
      "getAlarmHistory",
      "getAlarmStats",
      "getAllActiveAlarmsIncludingSilenced",
    ]),
  ],
  [
    SignalsApi,
    new Set([
      "getSignalPrefixes",
      "getSignals",
      "getSignalsExceedingThreshold",
    ]),
  ],
  [StarredObjectsApi, new Set(["getStarredObjectsForUser"])],
  [StatsApi, new Set(["getMenubarStats"])],
  [StickiesApi, new Set(["listStickies", "stickyHistory"])],
  [
    SupportEmailApi,
    new Set([
      "carrierInvoiceChallengeTemplate",
      "customsDelayNotificationDefaultContent",
      "previewAdditionalChargeEmail",
      "previewBookPickupEmail",
      "previewCardDeclinedEmail",
      "previewCarrierClaimEmail",
      "previewCarrierClaimNoticeEmail",
      "previewCarrierInvoiceChallengeEmail",
      "previewCompanyVerifiedEmail",
      "previewCustomerClaimAcknowledgementEmail",
      "previewCustomsDelayNotificationEmail",
      "previewFailedPaymentEmail",
      "previewGenericEmail",
      "previewInTransitEmail",
      "previewLogisticsAssistanceEmail",
      "previewMissedPickupEmail",
      "previewNoQuotesNotificationEmail",
      "previewPickupDayReminderEmail",
      "previewQuoteNotificationEmail",
      "previewRequestPhotosOfMissingFreightSupportEmail",
      "previewUploadCustomsDocsReminderEmail",
      "previewWaivedAdditionalChargeEmail",
      "previewWeightReportEmail",
      "requestPhotosOfMissingFreightDefaultContent",
      "uploadCustomsDocsReminderDefaultContent",
    ]),
  ],
  [
    TechnicalApi,
    new Set([
      "getAgentTaskRuns",
      "getAllClaudePrompts",
      "getEmailTemplates",
      "upsertClaudePrompt",
    ]),
  ],
  [
    TodosApi,
    new Set([
      "getMyTodoCounts",
      "getTodoById",
      "listTodosByAssignees",
      "listTodosForCarrier",
      "listTodosForCompany",
    ]),
  ],
  [TripwiresApi, new Set(["getAllTripwires"])],
]);
